export const events = [
    { value: "onCategoryChange('home')", label: "Ir a Home" },
    { value: "onCategoryChange('slot')", label: "Ir a Slot" },
    { value: "onCategoryChange('slotlive')", label: "Ir a Slot Live" },
    { value: "onCategoryChange('sportbook')", label: "Ir a Sportbook" },
    { value: "onCategoryChange('sportbooklive')", label: "Ir a Sportbook Live" },
    { value: "onCategoryChange('horses')", label: "Ir a Hipica" },
    { value: "onCategoryChange('crash')", label: "Ir a Crash Games" },
    { value: "onCategoryChange('scratch')", label: "Ir a Raspa y Gana" },
    { value: "onCategoryChange('virtual')", label: "Ir a Virtual" },
    { value: "openGame", label: "Abrir Juego" },
    { value: "openExternalUrl", label: "Ir una URL externa" }, 
    { value: "openBrand", label: "Abrir un proveedor" }
];